import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["bounds"];
import { createElementObject, createPathComponent, extendContext } from '@react-leaflet/core';
import { Rectangle as LeafletRectangle } from 'leaflet';
export var Rectangle = createPathComponent(function createRectangle(_ref, ctx) {
  var bounds = _ref.bounds,
    options = _objectWithoutProperties(_ref, _excluded);
  var rectangle = new LeafletRectangle(bounds, options);
  return createElementObject(rectangle, extendContext(ctx, {
    overlayContainer: rectangle
  }));
}, function updateRectangle(layer, props, prevProps) {
  if (props.bounds !== prevProps.bounds) {
    layer.setBounds(props.bounds);
  }
});